import { useState } from 'react';
import axios from 'axios';

export const useReceipts = (baseUrl, onRefresh) => {
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [receiptPreviewUrl, setReceiptPreviewUrl] = useState('');
  const [receiptPreviewTxnId, setReceiptPreviewTxnId] = useState(null);
  const [receiptModalTitle, setReceiptModalTitle] = useState('Receipt');

  const openReceipt = (txn) => {
    const url = txn.receipt_url || txn.receipt;
    if (!url) {
      console.warn('No receipt URL found for transaction', txn);
      return;
    }
    setReceiptPreviewUrl(url);
    setReceiptPreviewTxnId(txn.id);
    setReceiptModalTitle(`Receipt for ${txn.description || 'Transaction'}`);
    setShowReceiptModal(true);
  };

  const closeReceipt = () => {
    setShowReceiptModal(false);
    setReceiptPreviewUrl('');
    setReceiptPreviewTxnId(null);
  };

  const uploadReceipt = async (transactionId, file) => {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      await axios.post(`${baseUrl}/${transactionId}/upload-receipt/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (onRefresh) await onRefresh();
    } catch (e) {
      console.error('Failed to upload receipt', e);
      alert('Failed to upload receipt. Please try again.');
    }
  };

  const deleteReceipt = async () => {
    if (!receiptPreviewTxnId) return;
    try {
      await axios.delete(`${baseUrl}/${receiptPreviewTxnId}/delete-receipt/`);
      if (onRefresh) await onRefresh();
      closeReceipt();
    } catch (e) {
      console.error('Failed to delete receipt', e);
      alert('Failed to delete receipt. Please try again.');
    }
  };

  return {
    showReceiptModal,
    receiptPreviewUrl,
    receiptPreviewTxnId,
    receiptModalTitle,
    openReceipt,
    closeReceipt,
    uploadReceipt,
    deleteReceipt,
  };
};
